/**
 * Returns if product end has ended or not
 * @param {(string)} productEnd, a date string in ISO 8601
 * @returns {boolean}
 */
const hasPreAccessEnded = (productEnd) => {
    if (productEnd) {
        // @ts-expect-error ts-migrate(2362) FIXME: The left-hand side of an arithmetic operation must... Remove this comment to see the full error message
        return new Date() - new Date(productEnd) > 0;
    }
    return undefined;
};
export default hasPreAccessEnded;
//# sourceMappingURL=hasPreAccessEnded.js.map